module.exports = __webpack_public_path__ + "img/zhaichangfenxi.55ad267f.png";